import { render, staticRenderFns } from "./DevicesTable.vue?vue&type=template&id=3b1d2c4b&scoped=true"
import script from "./DevicesTable.vue?vue&type=script&lang=js"
export * from "./DevicesTable.vue?vue&type=script&lang=js"
import style0 from "./DevicesTable.vue?vue&type=style&index=0&id=3b1d2c4b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1d2c4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b1d2c4b')) {
      api.createRecord('3b1d2c4b', component.options)
    } else {
      api.reload('3b1d2c4b', component.options)
    }
    module.hot.accept("./DevicesTable.vue?vue&type=template&id=3b1d2c4b&scoped=true", function () {
      api.rerender('3b1d2c4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/attendances/devices/components/DevicesTable.vue"
export default component.exports